module.exports = __webpack_public_path__ + "static/media/illustrate-4.521f97e0.svg";